import { capitalize } from 'lodash';
import { User } from '@shared/types/user';
import { i18n } from '@shared/util/i18n';

// TODO(fant): i18n
export function assigneesToString(users: User[]): string {
  if (!users.length) {
    return i18n('card.blocks.assignee.unassigned');
  }
  const otherUsers = users.filter(u => !u.isMe);
  const me = users.find(u => u.isMe);

  if (!!me) {
    if (users.length === 1) {
      return `${capitalize(me.username)} (Me)`;
    }
    if (users.length === 2) {
      return `${capitalize(me.username)} (Me) and ${capitalize(otherUsers[0].username)}`;
    }

    return `${capitalize(me.username)} (Me) and +${otherUsers.length} others`;
  }

  if (users.length === 1) {
    return `${capitalize(users[0].username)}`;
  }
  if (users.length === 2) {
    return `${capitalize(users[0].username)} and ${capitalize(users[1].username)}`;
  }

  return `${capitalize(users[0].username)} and +${users.length - 1} others`;
}
